var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTagHotMobile = function SvgIconTagHotMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-tag-hot-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC164",
    d: "m21.22 7.903-6.268-.581-2.49-5.783a.502.502 0 0 0-.923 0l-2.49 5.783-6.27.581a.502.502 0 0 0-.285.878l4.73 4.155-1.384 6.142a.502.502 0 0 0 .746.543L12 16.406l5.414 3.215a.502.502 0 0 0 .746-.543l-1.384-6.142 4.73-4.155a.502.502 0 0 0-.285-.878"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE82",
    d: "M5.591 1.34c.32.444 1.222 2.35 1.738 3.462.08.175-.138.332-.278.2C6.16 4.16 4.639 2.7 4.319 2.256a.784.784 0 1 1 1.272-.915M18.409 1.34c-.32.444-1.222 2.35-1.737 3.462-.082.175.137.332.277.2.89-.842 2.412-2.302 2.732-2.746a.784.784 0 0 0-1.272-.915M23.46 14.358c-.52-.17-2.611-.45-3.826-.604-.191-.024-.275.233-.107.326 1.072.592 2.926 1.599 3.446 1.768a.784.784 0 0 0 .486-1.49M.54 14.358c.52-.17 2.611-.45 3.826-.604.191-.024.275.233.107.326-1.072.592-2.926 1.599-3.446 1.768a.784.784 0 0 1-.486-1.49M11.24 23.202c0-.547.382-2.62.613-3.824.036-.189.306-.189.342 0 .231 1.203.613 3.277.613 3.824a.784.784 0 1 1-1.568 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-tag-hot-mobile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgIconTagHotMobile;